import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Button } from '../shared/domain/button';
import { SessionService } from '../shared/services/session/session.service';

@Component({
  moduleId: module.id,
  selector: 'vit-stake-input',
  templateUrl: 'stake-input.component.html',
  styleUrls: ['stake-input.component.scss']
})
export class StakeInputComponent {

  buttons: Button[] = [];
  initial: boolean;

  @Input()
  hideFirstRow: boolean = false;
  @Input()
  value: string = '';
  @Input()
  min: number = 0;
  @Input()
  max: number;

  @Output()
  stakeEmitter = new EventEmitter<number>();
  @Output()
  intermediateStakeEmitter = new EventEmitter<string>();

  constructor(public sessionService: SessionService) {
    this.buttons = this.generateButtons();
    this.handleMinStake();
    this.handleMaxStake();
    this.initial = true;
  }

  cancel(): void {
    this.stakeEmitter.emit(null);
  }

  plus(): void {
    this.value = Math.floor(+this.value + 1).toString();
    this.handleMaxStake();
    this.initial = false;
  }

  minus(): void {
    this.value = Math.floor(+this.value - 1).toString();
    this.handleMinStake();
    this.initial = false;
  }

  ok(): void {
    this.handleMinStake();
    this.stakeEmitter.emit(+this.value);
  }

  handleMinStake(): void {
    if (+this.value < this.min) {
      this.value = this.min.toString();
    }
  }

  handleMaxStake(): void {
    if (this.max && +this.value > this.max) {
      this.value = this.max.toString();
    }
  }

  handleMaxDecimalPlaces(): void {
    var splitedNumber: string[] = this.value.split('.');
    if (splitedNumber.length > 1 && splitedNumber[1].length > 2) {
      this.value = splitedNumber[0] + '.' + splitedNumber[1].slice(0, 2);
    }
  }

  click(key: string): void {
    switch (key) {
      case '.':
        if (!this.initial && this.value && this.value.indexOf('.') === -1) {
          this.value += key;
        } else if (this.value === '' || this.initial) {
          this.value = '0.';
        }
        break;
      case 'DEL':
        if (this.value === '0.') {
          this.value = '';
        } else {
          this.value = this.value.slice(0, -1);
        }
        break;
      case '0':
        if (!this.initial && (+this.value > 0 || this.value === '0.')) {
          this.value += key;
        } else if (this.value === '' || this.initial) {
          this.value = '0.';
        }
        break;
      default:
        if (this.initial) {
          this.value = key;
        } else {
          this.value += key;
        }
    }
    this.initial = false;
    this.handleMaxStake();
    this.handleMaxDecimalPlaces();

    if (this.hideFirstRow) {
      this.intermediateStakeEmitter.emit(this.value);
    }
  }

  generateButtons(): Button[] {
    return [
      new Button('1', '1'),
      new Button('2', '2'),
      new Button('3', '3'),
      new Button('4', '4'),
      new Button('5', '5'),
      new Button('6', '6'),
      new Button('7', '7'),
      new Button('8', '8'),
      new Button('9', '9'),
      new Button('fa fa-long-arrow-left', 'DEL'),
      new Button('0', '0'),
      new Button(',', '.')];
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/stake-input/stake-input.component.ts